import { AvailableLanguage, TranslatableText } from '@/types';

export const translateConfigValue = (
  value: TranslatableText | undefined,
  language: AvailableLanguage
): string | undefined => {
  if (value == null) {
    return undefined;
  }

  if (typeof value === 'string') {
    return value;
  }

  if (value[language]) {
    return value[language];
  }

  const fallbackOrder: AvailableLanguage[] = ['de', 'en'];

  for (const fallback of fallbackOrder) {
    if (fallback === language) {
      continue;
    }

    const translated = value[fallback];

    if (translated) {
      return translated;
    }
  }

  const [firstAvailable] = Object.values(value).filter(
    (entry): entry is string => typeof entry === 'string'
  );

  return firstAvailable;
};
